<template>
  <!-- 角色管理 -->
  <div class="wrapper">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-user-solid title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-count">
          <span class="count-label">共</span>
          <span class="count-value">{{ total }}</span>
          <span class="count-label">条记录</span>
        </div>
      </div>
    </div>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div slot="header" class="card-header">
        <i class="el-icon-s-order"></i>
        <span>角色列表</span>
        <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.role_list_add)"
            type="primary"
            size="small"
            class="add-btn"
            @click="showAddOrEdit = true;rowId = null"
        >
          <i class="el-icon-plus"></i>
          <span>新增</span>
        </el-button>
      </div>

      <tp-table
          :isNeedSerialNumber="true"
          :tableData="roleList"
          :columns="columns"
          :totalNum="total"
          :current-page.sync="currentPage"
          :pageSize.sync="pageSize"
      />
    </el-card>

    <!-- 授权 -->
    <el-drawer 
        ref="drawer" 
        title="角色权限" 
        :visible.sync="drawer" 
        :show-close="false"
        size="500px"
        class="authority-drawer"
    >
      <div slot="title" class="drawer-title">
        <i class="el-icon-key"></i>
        <span>角色权限设置</span>
      </div>
      <el-card class="authority-card" shadow="never">
        <div slot="header" class="card-header">
          <i class="el-icon-menu"></i>
          <span>菜单权限</span>
          <el-button type="primary" size="small" class="save-authority-btn" @click="saveAuthority">
            <i class="el-icon-check"></i>
            <span>保存设置</span>
          </el-button>
        </div>
        <div class="tree-container">
          <el-tree
              ref="tree"
              highlight-current
              :data="menuTree"
              show-checkbox
              node-key="id"
              default-expand-all
              :default-checked-keys="grantMenuObj.menuIdList"
              :props="defaultProps"
              @check="checkChange"
          >
          </el-tree>
        </div>
      </el-card>
    </el-drawer>

    <!-- 新增&编辑 -->
    <AddOrEdit
        v-if="showAddOrEdit"
        :rowId="rowId"
        :showAddOrEdit="showAddOrEdit"
        @closeDialog="closeDialogFun"
    />
  </div>
</template>

<script>
import { getRoleList, removeRole, getMenusTree, grantMenu, getRoleDetail } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import AddOrEdit from "./add-edit.vue";

const columns = [
  {
    label: '角色',
    prop: 'roleName',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['roleName']}>
            {row['roleName']}
          </p>
      )
    }
  },
  {
    label: '描述',
    prop: 'remark',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['remark']}>
            {row['remark']}
          </p>
      )
    }
  },
  {
    label: '创建时间',
    prop: 'createTime',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['createTime']}>
            {row['createTime']}
          </p>
      )
    }
  },
  {
    label: '操作',
    width: '180',
    customRender(h, row) {
      return (
          <div>
            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.role_list_edit)}
                underline={false}
                type="primary"
                onClick={() =>{
                  this.showAddOrEdit = true;
                  this.rowId = row["id"];
                }}
            >
              编辑
            </el-link>

            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.role_list_grant)}
                underline={false}
                style="margin:0 10px"
                type="primary"
                onClick={() => this.showMenu(row['id'])}
            >
              授权
            </el-link>

            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.role_list_del)}
                underline={false}
                type="danger"
                onClick={() => this.delRole(row['id'])}
            >
              删除
            </el-link>
          </div>
      )
    }
  }
];

export default {
  name: 'SystemRoleAddOrEdit',
  mixins: [authBtnMixin],
  components: { AddOrEdit },
  data() {
    return {
      menuModule: 'admin',
      drawer: false,
      roleList: [],
      columns,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      defaultProps: {
        children: 'children',
        label: 'menuName',
        value: 'id'
      },
      menuTree: [],
      // 授权信息
      grantMenuObj: {
        id: null,
        menuIdList: []
      },
      searchData: {
        roleName: ''
      },
      allKeys: [],
      rowId: null,
      showAddOrEdit: false,
    }
  },
  provide() {
    return {
      context: this
    }
  },
  watch: {
    currentPage() {
      this.getRoleList();
    }
  },
  mounted() {
    this.getRoleList();
    this.apiQueryMenuTree();
  },

  methods: {
    async getRoleList() {
      let params = { roleName: this.searchData.roleName, page: this.currentPage, pageSize: this.pageSize };
      let res = await getRoleList(params);
      this.roleList = res?.list || [];
      this.total = res?.total || 0;
    },

    async apiQueryMenuTree() {
      this.menuTree = await getMenusTree();
    },
    // 复选框被点击时的回调
    checkChange() {
      // 获取当前被选中的菜单id数组
      this.grantMenuObj.menuIdList = this.$refs.tree.getCheckedKeys();
      this.allKeys = this.$refs.tree.getCheckedNodes(false, true).map(item => item.id);
    },
    // 保存菜单授权
    async saveAuthority() {
      let data = { id: this.grantMenuObj.id, menuIdList: this.allKeys };
      await grantMenu(data).then(() => {
        this.$message.success('授权成功');
        this.drawer = false;
        this.getRoleList();
      })
    },
    async delRole(id) {
      this.$confirm('确定要删除该角色吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            removeRole({ id }).then(() => {
              this.$message.success('删除成功');
              this.getRoleList();
            })
          })
          .catch(() => {})
    },
    async showMenu(id) {
      this.grantMenuObj.menuIdList = [];
      this.apiQueryMenuTree();
      this.drawer = true;
      this.grantMenuObj.id = id;
      const { menuList } = await getRoleDetail({ id });
      this.$nextTick(() => {
        this.grantMenuObj.menuIdList = this.fileterMenuIds(menuList).filter(item => !this.$refs.tree.getNode(item).childNodes.length);
      })
    },
    fileterMenuIds(list) {
      let menuIds = [];
      list.forEach(item => {
        if (item.children && item.children.length > 0) {
          menuIds = this.fileterMenuIds(item.children);
        } else {
          menuIds.push(item.id);
        }
      })
      return menuIds;
    },
    handleClick() {
      this.getRoleList()
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getRoleList()
    },
    // 关闭弹框
    closeDialogFun(flag) {
      this.showAddOrEdit = false;
      if (flag) {
        this.getRoleList();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-count {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    
    .count-label {
      color: #909399;
    }
    
    .count-value {
      color: #409EFF;
      font-weight: 600;
      font-size: 18px;
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  .card-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    
    i {
      font-size: 18px;
      margin-right: 8px;
    }
    
    .add-btn {
      margin-left: auto;
      border-radius: 10px;
      padding: 8px 20px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      letter-spacing: 0.3px;
      display: inline-flex;
      align-items: center;
      gap: 6px;

      &:hover:not(.is-disabled) {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      }
    }
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }
  
  // 操作链接样式
  ::v-deep .el-link {
    transition: all 0.3s ease;
    
    &:hover {
      opacity: 0.8;
      transform: translateY(-1px);
    }
  }
}

// 授权抽屉样式
::v-deep .authority-drawer {
  .el-drawer {
    .el-drawer__header {
      margin-bottom: 0;
      padding: 20px 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      border-bottom: none;
    }
    
    .el-drawer__body {
      padding: 0;
      background: #f5f7fa;
    }
  }
  
  .drawer-title {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    
    i {
      font-size: 20px;
    }
  }
  
  .authority-card {
    margin: 20px;
    border-radius: 12px;
    border: none;
    background: #ffffff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    
    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      
      i {
        font-size: 18px;
        color: #409EFF;
        margin-right: 8px;
      }
      
      .save-authority-btn {
        border-radius: 10px;
        padding: 8px 20px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;
        display: inline-flex;
        align-items: center;
        gap: 6px;

        &:hover:not(.is-disabled) {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }
    }
    
    .tree-container {
      max-height: calc(100vh - 200px);
      overflow-y: auto;
      padding: 10px 0;
      
      // 自定义滚动条
      &::-webkit-scrollbar {
        width: 6px;
      }
      
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
        
        &:hover {
          background: #a8a8a8;
        }
      }
      
      ::v-deep .el-tree {
        .el-tree-node__content {
          height: 36px;
          border-radius: 6px;
          margin-bottom: 4px;
          transition: all 0.3s ease;
          
          &:hover {
            background: rgba(64, 158, 255, 0.08);
          }
        }
        
        .el-tree-node.is-current > .el-tree-node__content {
          background: rgba(64, 158, 255, 0.12);
          color: #409EFF;
          font-weight: 600;
        }
        
        .el-checkbox {
          .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #409EFF;
            border-color: #409EFF;
          }
          
          .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #409EFF;
            border-color: #409EFF;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .wrapper {
    padding: 16px;
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  ::v-deep .authority-drawer {
    .el-drawer {
      width: 90% !important;
    }
  }
}
</style>
